import { NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "./footer.scss";
import exploreInactive from "../../assets/exploreInactive.svg";
import paybillInactive from "../../assets/paybillInactive.svg";
import profileInactive from "../../assets/profileInactive.svg";
import exploreActive from "../../assets/exploreActive.svg";
import paybillActive from "../../assets/paybillActive.svg";
import profileActive from "../../assets/profileActive.svg";

const Footer = () => {
  const location = useLocation();
  const [exploreIcon, setExploreIcon] = useState(exploreInactive);
  const [paybillIcon, setPaybillIcon] = useState(paybillActive);
  const [profileIcon, setProfileIcon] = useState(profileInactive);
  const [isExploreActive, setIsExploreActive] = useState(false);
  const [isPaybillActive, setIsPaybillActive] = useState(true);
  const [isProfileActive, setIsProfileActive] = useState(false);

  useEffect(() => {
    switch(location.pathname){
      case "/explore": 
        setExploreIcon(exploreActive);
        setPaybillIcon(paybillInactive);
        setProfileIcon(profileInactive);
        setIsExploreActive(true);
        setIsPaybillActive(false);
        setIsProfileActive(false);
        break;
      case "/outlet-list": 
        setExploreIcon(exploreInactive);
        setPaybillIcon(paybillActive);
        setProfileIcon(profileInactive);
        setIsExploreActive(false);
        setIsPaybillActive(true);
        setIsProfileActive(false);
        break;
      case "/profile": 
        setExploreIcon(exploreInactive);
        setPaybillIcon(paybillInactive);
        setProfileIcon(profileActive);
        setIsExploreActive(false);
        setIsPaybillActive(false);
        setIsProfileActive(true);
        break;
      default:
        setExploreIcon(exploreInactive);
        setPaybillIcon(paybillActive);
        setProfileIcon(profileInactive);
        setIsExploreActive(false);
        setIsPaybillActive(true);
        setIsProfileActive(false);
        break; 
    }
  }, [location.pathname])

  return (
    <div className="footer-content">
      <NavLink to="/explore" className={isExploreActive ? "footer-item active" : "footer-item"}>
        <hr className="hr" />
        <img className="footer-icons" src={exploreIcon} alt="" />
        <div className="footer-text">Explore</div>
      </NavLink>
      <NavLink to="/outlet-list" className={isPaybillActive ? "footer-item active" : "footer-item"}>
        <hr className="hr" />
        <img className="footer-icons" src={paybillIcon} alt="" />
        <div className="footer-text">Paybill</div>
      </NavLink>
      <NavLink to="/profile" className={isProfileActive ? "footer-item active" : "footer-item"}>
        <hr className="hr" />
        <img className="footer-icons" src={profileIcon} alt="" />
        <div className="footer-text">Profile</div>
      </NavLink>
    </div>
  );
};

export default Footer;
